import { render } from "./FleetApplications.vue?vue&type=template&id=94d9e658&ts=true"
import script from "./FleetApplications.vue?vue&type=script&lang=ts"
export * from "./FleetApplications.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__